import { createContext, useContext } from "react";
let e = createContext(void 0);
function a() {
  return useContext(e);
}
export {
  a as useDisabled
};
